import { Formatter } from '@softline/ui-core';
import { Column } from './grid';
import { GridDataSource } from './grid-data-source';

export class GridRef<TRow extends object> {
  readonly columns: Column<TRow>[] = [];

  constructor(public readonly dataSource: GridDataSource<TRow>,
              public readonly formatter: Formatter) {
  }

  createColumn(column: Column<TRow>): void{
    this.columns.push(column);
  }

  createRequest(dataSource: any): void{

  }
}

export class GroupColumnRef<TRow extends object> {
  readonly columns: Column<TRow>[] = [];

  constructor(public readonly formatter: Formatter) {
  }

  createColumn(column: Column<TRow>): void{
    this.columns.push(column);
  }

  createRequest(dataSource: any): void{
  }
}


export class EntityColumnRef<TEntity extends object> {
  readonly columns: Column<TEntity>[] = [];

  constructor(public readonly formatter: Formatter) {
  }

  createColumn(column: Column<TEntity>): void{
    this.columns.push(column);
  }

  createRequest(dataSource: any): void{
  }
}
